// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { getInputStylesCss } from '../internal/utils/input-styles';
export function getTextareaStyles(style) {
    return getInputStylesCss(style, true);
}
//# sourceMappingURL=styles.js.map